export default [
    {
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "PERSONAL TYPE",
        options: [
            { value: 0, text: "ALL" },
            { value: 1, text: "EMPLOYEE" },
            { value: 2, text: "DRIVER" },
            { value: 4, text: "STEVEDORE" },
        ],
        model: null,
        cols: 6,
    },
    {
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "VIATIC",
        options: [
            { value: 0, text: "ALL" },
            { value: 1, text: "APPLY" },
            { value: 2, text: "NOT APPLY" },
        ],
        model: null,
        cols: 6,
    },
    {
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "entity group",
        options: [],
        model: null,
        cols: 12,
    },
    {
        type: "b-form-select",
        margin: true,
        showLabel: true,
        label: "STATUS PERSONAL",
        options: [
            { value: 0, text: "ALL" },
            { value: 1, text: "ACTIVE" },
            { value: 2, text: "INACTIVE" },
            { value: 3, text: "SUSPEND" },
        ],
        model: null,
        cols: 12,
    },
];